import { useEffect, useState } from "react";
import { LuDot } from "react-icons/lu";

const FileUpload = ({
    id,
    accept,
    onChange,
    required,
    multiple,
}) => {
    return (
        <div className="relative border p-1 border-gray">
            <input
                type="file"
                id={id}
                name={id}
                accept={accept}
                onChange={onChange}
                className="block w-full text-sm text-main-subfont
                    file:me-4 file:py-2 file:px-4
                    file:rounded-lg file:border-0
                    file:text-sm file:font-semibold
                    file:bg-main-blue file:text-main-white
                    hover:file:bg-blue-700
                    file:disabled:opacity-50 file:disabled:pointer-events-none
                    focus:outline-none focus:ring-2 focus:ring-main-blue cursor-pointer"

                required={required}
                multiple={multiple}
            />
        </div>
    );
};

export default FileUpload;
